import { ReplyButton } from "../model/ReplyButton";

export const createEvenReplyButtons = (): ReplyButton[] => {
  return [
    {
      id: "undefined",
      name: "",
      buttonNumber: 0,
      buttonName: [""],
      buttonColor: [],
      type: "",
      createUser: "",
      createAt: new Date()
    },
    {
      id: 'eventReplyButton0001',
      name: '予定表の出欠(オンライン)',
      buttonNumber: 3,
      buttonName: ['会場で参加', 'オンラインで参加', '欠席'],
      buttonColor: ['0', '2', '1'],
      type: 'admin',
      createUser: '',
      createAt: new Date(),
    },
    {
      id: 'eventReplyButton0002',
      name: '予定表の出欠',
      buttonNumber: 2,
      buttonName: ['会場で参加', '欠席'],
      buttonColor: ['0', '1'],
      type: 'admin',
      createUser: '',
      createAt: new Date(),
    },
  ]
};